import React, { memo } from 'react';

import bn from '../../generalUtils/benames';
import { LOADING, NODATAFOUND, NOPERMISSION } from '../../constants/messageConst';
import withRoutingProps from '../../hooks/withRoutingProps';

const bem = bn.create('customCard');

const CustomCard = ({
  isCardLoading = false,
  isErrorInCard = false,
  isNoData = false,
  isNoPermission = false,
  //------------------------//
  id = undefined,
  addedClass = null,
  addedCardBodyClass = null,
  title = null,
  addedCardTitleClass = '',
  titleClassName = null,
  titleRenderElement = null,
  smalltitle = null,
  smallTitleRenderElement = null,
  children,
  isShowCard = true,
  isHideHeaderDiv = false,
  onClick = null,
  onTitleClick = null,
  cardbodyMaxHeight = null,
  isUnderConstuction = false,
  isLightTheme
}) => {
  const childrenRenderJSX = () => {
    if (isCardLoading) {
      return <div className={`${isLightTheme ? 'text-info-300' : 'text-info'} p-3`}>{LOADING}</div>;
    }
    if (isErrorInCard) {
      return (
        <div className="text-danger pt-2 pl-3">
          <i className="fa fa-fw fa-exclamation" aria-hidden="true" />
          Error in loading data.
        </div>
      );
    }

    if (isUnderConstuction) {
      return (
        <div className="customcard-body text-center mx-auto text-sm-center text-md-center text-lg-center text-xl-center p-3">
          <h3 className="text-warning">UNDER CONSTRUCTION</h3>
          <div className="p">
            <p>Hello! We&rsquo;re currently building this section. Please come back later.</p>
            <p>- The React Team</p>
          </div>
        </div>
      );
    }

    if (children) {
      return (
        <div
          className={`customcard-body d-block ${addedCardBodyClass ? addedCardBodyClass : ''}`}
          style={{
            maxHeight: cardbodyMaxHeight !== 0 ? `${cardbodyMaxHeight}rem` : 0,
            important: 'true'
          }}
        >
          {children}
        </div>
      );
    }
    if (isNoData) {
      return (
        <div className={`text-danger  ${addedCardBodyClass ? addedCardBodyClass : ' pt-2 pl-3'}`}>
          <i className="fa fa-fw fa-exclamation" aria-hidden="true" /> {NODATAFOUND}
        </div>
      );
    }
    if (isNoPermission) {
      return (
        <div className={`text-danger  ${addedCardBodyClass ? addedCardBodyClass : ' pt-2 pl-3'}`}>
          <i className="fa fa-fw fa-exclamation" aria-hidden="true" /> {NOPERMISSION}
        </div>
      );
    }
    return null;
  };

  return (
    <div
      id={!isShowCard ? `notShownCard ${id || ''}` : id || ''}
      className={bem.b(
        `justify-content-around cursor-auto ${addedClass ? addedClass : ''} ${
          !isShowCard ? 'notShownCard' : ''
        }`
      )}
      onClick={onClick}
    >
      {isHideHeaderDiv ? (
        <div className="pt-2" />
      ) : (
        (title || titleRenderElement || smalltitle || smallTitleRenderElement) && (
          <div className={`cardTitle ${addedCardTitleClass}`} onClick={onTitleClick}>
            <div className="d-inline-block divTitle w-100">
              {title && titleRenderElement ? (
                <div className="titleSelection" title={typeof title === 'string' ? title : ''}>
                  {title && <span className="titleLabel">{title}</span>}
                  {titleRenderElement && <div>{titleRenderElement}</div>}
                </div>
              ) : (
                <>
                  {title && (
                    <div
                      className={titleClassName ? titleClassName : 'titleSelection'}
                      title={typeof title === 'string' ? title : ''}
                    >
                      {title && <span className="titleLabel">{title}</span>}
                    </div>
                  )}
                  {titleRenderElement && <div className="titlerenderelement">{titleRenderElement}</div>}
                </>
              )}

              {smalltitle && smallTitleRenderElement ? (
                <div className="smalltitleSelection" title={typeof smalltitle === 'string' ? smalltitle : ''}>
                  {smalltitle && (
                    <span className="text-muted text-capitalize smalltitleLabel">{smalltitle}</span>
                  )}
                  {smallTitleRenderElement && <div className="">{smallTitleRenderElement}</div>}
                </div>
              ) : (
                <>
                  {smalltitle && (
                    <div
                      className="smalltitleSelection"
                      title={typeof smalltitle === 'string' ? smalltitle : ''}
                    >
                      {smalltitle && (
                        <span className="text-muted text-capitalize smalltitleLabel">{smalltitle}</span>
                      )}
                    </div>
                  )}
                  {smallTitleRenderElement && (
                    <div className="smallrenderelement">{smallTitleRenderElement}</div>
                  )}
                </>
              )}
            </div>
          </div>
        )
      )}

      {childrenRenderJSX()}
    </div>
  );
};

CustomCard.displayName = 'CustomCard';
export default memo(withRoutingProps(CustomCard));
